module.exports = __webpack_public_path__ + "static/media/texture.f45868ef.svg";